import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  entities: [],
  loading: false,
  error: null,
};

const entitiesSlice = createSlice({
  name: 'entities',
  initialState,
  reducers: {
    addEntity: (state, action) => {
      state.entities.push(action.payload);
    },
    updateEntity: (state, action) => {
      const { id, updates } = action.payload;
      const entityIndex = state.entities.findIndex(entity => entity.id === id);
      if (entityIndex !== -1) {
        state.entities[entityIndex] = { ...state.entities[entityIndex], ...updates };
      }
    },
    removeEntity: (state, action) => {
      state.entities = state.entities.filter(entity => entity.id !== action.payload);
    },
    setEntities: (state, action) => {
      state.entities = action.payload;
    },
    clearEntities: (state) => {
      state.entities = [];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  addEntity,
  updateEntity,
  removeEntity,
  setEntities,
  clearEntities,
  setLoading,
  setError,
} = entitiesSlice.actions;

// Selectors
export const selectAllEntities = (state) => state.entities.entities;
export const selectEntityById = (state, id) => 
  state.entities.entities.find(entity => entity.id === id);
export const selectEntitiesLoading = (state) => state.entities.loading;
export const selectEntitiesError = (state) => state.entities.error;
export const selectEntitiesCount = (state) => state.entities.entities.length;
export const selectAverageSpread = (state) => {
  const entities = state.entities.entities;
  if (entities.length === 0) return 0;
  const totalSpread = entities.reduce((sum, entity) => sum + parseFloat(entity.spread), 0);
  return (totalSpread / entities.length).toFixed(2);
};

export default entitiesSlice.reducer;